// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0f0bb722] .modal_body {\n  overflow-y: visible !important;\n}\n.fade-enter-active[data-v-0f0bb722],\n.fade-leave-active[data-v-0f0bb722] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-0f0bb722], .fade-leave-to[data-v-0f0bb722] {\n  opacity: 0;\n}\n.gogonghome[data-v-0f0bb722] {\n  padding-top: 4px;\n}", ""]);
// Exports
module.exports = exports;
